export default {
  /**
   * For the current geo selection, get the associated country attr in the stats table
   * TODO: used in stat comp. Should refactor to helpers file or pass from parent
   */
  getCountryAttrForSelectedGeometry: (selectedGeometry) => {
    switch (selectedGeometry) {
      case "Eastern Caribbean":
      case "The Region":
        return "Total_of_all_countries";
      case "CROP Countries":
        return "Crop_Countries";
      case "Anguilla":
        return "Anguilla";
      case "Antigua And Barbuda":
        return "Antigua_and_Barbuda";
      case "Barbados":
        return "Barbados";
      case "Dominica":
        return "Dominica";
      case "Grenada":
        return "Grenada";
      case "Guadeloupe":
        return "Guadeloupe";
      case "Martinique":
        return "Martinique";
      case "Montserrat":
        return "Montserrat";
      case "Saba":
        return "Saba";
      case "Saint Barthelemy":
        return "Saint_Barthelemy";
      case "Saint Martin":
        return "Saint_Martin";
      case "Saint Kitts and Nevis":
        return "Saint_Kitts_and_Nevis";
      case "Saint Lucia":
        return "Saint_Lucia";
      case "Saint Vincent and the Grenadines":
        return "Saint_Vincent_and_the_Grenadine";
      case "Sint Eustatius":
        return "Sint_Eustatius";
      case "Sint Maarten":
        return "Sint_Maarten";
      default:
        return "Total_of_these_5_countries";
    }
  },

  getCountryForEEZ: (selectedGeometry) => {
    switch (selectedGeometry) {
      case "Anguilla":
        return "ANGUILLA";
      case "Antigua And Barbuda":
        return "ANTIGUA AND BARBUDA";
      case "Barbados":
        return "BARBADOS";
      case "Dominica":
        return "DOMINICA";
      case "Grenada":
        return "GRENADA";
      case "Guadeloupe":
        return "GUADELOUPE";
      case "Martinique":
        return "MARTINIQUE";
      case "Montserrat":
        return "MONTSERRAT";
      case "Saba":
        return "SABA";
      case "Saint Barthelemy":
        return "SAINT-BARTHELEMY";
      case "Saint Martin":
        return "SAINT-MARTIN";
      case "Saint Kitts and Nevis":
        return "SAINT KITTS AND NEVIS";
      case "Saint Lucia":
        return "SAINT LUCIA";
      case "Saint Vincent and the Grenadines":
        return "SAINT VINCENT AND THE GRENADINES";
      case "Sint Eustatius":
        return "SINT-EUSTATIUS";
      case "Sint Maarten":
        return "SINT-MAARTEN";
      default:
        return "";
    }
  },

  doesMouseIntersect: (elem, x, y) => {
    if (elem) {
      const rect = elem.getBoundingClientRect();
      const { left, top, width, height } = rect;
      const buffer = 35;
      const xMin = left - buffer;
      const xMax = left + width + buffer;
      const yMin = top - buffer;
      const yMax = top + height + buffer;
      const result = x > xMin && x < xMax && y > yMin && y < yMax;
      return result;
    }

    return false;
  },
};
